import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialData } from "constants/initialData";

type calculatorState = {
    monthlyInvestment: number;
    totalInvesion: number;
    plantsNumber: number;
    contributionPeriod: number;
    anualIng: any;
    acumulateInversion:any;
    displayBarGraph: boolean;
    totalAccumulatedIncome: number;
    TIwithoutHitch: number;
    totalInversion: number;
    invertionType: string;
    investment: any

};

const initialState = {
    monthlyInvestment:27500,
    totalInvesion:990000,
    TIwithoutHitch:990000,
    plantsNumber: 1800,
    contributionPeriod: 36,
    anualIng:initialData,
    acumulateInversion:[330000, 660000, 990000],
    displayBarGraph: false,
    totalAccumulatedIncome:8828817.86,
    totalInversion: 990000,
    invertionType:"unica",
    investment:[330000, 330000, 330000]

} as calculatorState;

export const calculatorSlice = createSlice({
    name: "calculatorSlice",
    initialState,
    reducers: {


        setTotalInversion: (state, action: PayloadAction<number>) => {
            state.totalInversion = action.payload
        },

        setMonthlyInvestment: (state, action: PayloadAction<number>) => {
            state.monthlyInvestment = action.payload
        },

        setPlansNumbers: (state, action: PayloadAction<number>) => {
            state.plantsNumber = action.payload
        },

        setContributionPeriod: (state, action: PayloadAction<number>) => {
            state.contributionPeriod = action.payload
        },

        setAnualIng: (state, action: PayloadAction<any>) => {
            state.anualIng = action.payload
        },
        setDisplayBarGraph: (state, action: PayloadAction<boolean>) => {
            state.displayBarGraph = action.payload
        },
        setAcumulateInversion: (state, action: PayloadAction<any>) => {
            state.acumulateInversion = action.payload
        },
        setTotalAcumulatedIncome: (state, action: PayloadAction<number>) => {
            state.totalAccumulatedIncome = action.payload
        },
        setTIwithoutHitch: (state, action: PayloadAction<number>) => {
            state.TIwithoutHitch = action.payload
        },
        setInvertionType: (state, action: PayloadAction<string>) => {
            state.invertionType = action.payload
        },

        setInvestment: (state, action: PayloadAction<any>) => {
            state.investment = action.payload
        }


    },

});

export const {
    setMonthlyInvestment,
    setTotalInversion,
    setPlansNumbers,
    setContributionPeriod,
    setAnualIng,
    setDisplayBarGraph,
    setAcumulateInversion,
    setTotalAcumulatedIncome,
    setTIwithoutHitch,
    setInvertionType,
    setInvestment
} = calculatorSlice.actions;
export default calculatorSlice.reducer;
